import type { ThemeMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'
import { FaPhone } from 'react-icons/fa'

import { AlertTriangleIcon, StatusPill } from '@hivewatch/dark'

interface DarkEmergencyCallConfigurationStatusIProps {
  isEnabled: boolean
  isConfigured: boolean
  colorScheme: ThemeMode
}

/**
 * Rebrand variant of {@link EmergencyCallConfigurationStatus} that surfaces the
 * emergency-calling state as a dark `StatusPill`, matching the pills rendered in
 * `DarkFacilityRowCard`. Must be rendered within a `DarkProvider` (or a dark
 * `Modal`, which supplies its own).
 */
export const DarkEmergencyCallConfigurationStatus = ({
  isEnabled,
  isConfigured,
  colorScheme,
}: DarkEmergencyCallConfigurationStatusIProps) => {
  const { t } = useTranslation()

  if (!isEnabled) {
    return null
  }

  return isConfigured ? (
    <StatusPill
      colorScheme={colorScheme}
      icon={<FaPhone size={10} />}
      label={t('facilities:ec_badge_configured')}
      variant='success'
    />
  ) : (
    <StatusPill
      colorScheme={colorScheme}
      icon={
        <AlertTriangleIcon color='currentColor' size={12} strokeWidth={2} />
      }
      label={t('facilities:ec_status_not_configured')}
      variant='warning'
    />
  )
}
